import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { AuthService } from "src/app/_services/auth.service";
import { MessageTypeEnum } from "src/app/_enums/message-type.enum";
import { SnackbarService } from "src/app/_services/snackbar.service";

@Injectable({
    providedIn: "root",
})
export class SuperadminGuard implements CanActivate {
    constructor(
        private router: Router,
        private authService: AuthService,
        private readonly snackbarService: SnackbarService,
    ) {}

    canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (state.url.includes("app/superadmin")) {
            if (this.authService.isSuperAdmin) {
                return true;
            } else {
                this.snackbarService.show({ message: "Login as superadmin first", type: MessageTypeEnum.ERROR });
                this.router.navigate(["app", "dashboard"]);

                return false;
            }
        }

        return true;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }
}
